import type { DetailsPageProps } from '@shared/types/details-page-props';
import type { HotelImageType } from '@skyscanner-internal/hotel-unified-bff-web-http-client/dist/skyscanner/hotelunifiedbff/hotelcontent/v1/hotel_content.pb';

import {
  MAX_PREVIEW_IMAGES_COUNT,
  VIDEOS_CATEGORY,
  VIDEOS_INDEX_IN_GALLERY,
} from '@hotels-hotel-detail/utils/hotel-images';
import { usePageProps } from '@shared/data-access-frontend/contexts/props-context';

export const useDetailPageProps = () => usePageProps<DetailsPageProps>();

export const useHotelContent = () => {
  const { uBFFHotel } = useDetailPageProps();
  return uBFFHotel;
};

export const useHotelBasicInfo = () => {
  const {
    confidentReview,
    gallery,
    hotelId,
    location,
    name,
    reviewSummary,
    stars,
  } = useHotelContent();

  return {
    hotelId,
    name,
    stars,
    confidentReview,
    location,
    reviewSummary,
    hasNoMedia: gallery.images.length === 0,
  };
};

export const useHotelCheckinCheckoutTimes = () => {
  const { checkinTime, checkoutTime } = useHotelContent();
  return { checkin: checkinTime, checkout: checkoutTime };
};

export const useHotelPolicies = () => {
  const { hotelPolicies } = useHotelContent();
  return hotelPolicies;
};

export const useHotelPreviewImages = () => {
  const { description, gallery, imageCount } = useHotelContent();

  const { images: descImagesPreview = [] } = description ?? {};
  const { images = [], video } = gallery ?? {};

  const heroImagesPreview: Array<{
    url: string;
    type: HotelImageType | typeof VIDEOS_CATEGORY;
  }> = [...images];
  if (video) {
    heroImagesPreview.splice(VIDEOS_INDEX_IN_GALLERY, 0, {
      url: video.thumbnail,
      type: VIDEOS_CATEGORY,
    });
  }

  return {
    descImagesPreview: descImagesPreview.slice(0, MAX_PREVIEW_IMAGES_COUNT),
    heroImagesPreview: heroImagesPreview.slice(0, MAX_PREVIEW_IMAGES_COUNT),
    imageCount,
  };
};
